import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sentenceCase',
  standalone: false
})
export class SentenceCasePipe implements PipeTransform {
  transform(value:string): string {
    if (!value) {
      return '';
    }
    let string = value.toLowerCase();
    let first = string.substring(0,1).toUpperCase();
    return first + string.substring(1);
  }
}
